"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalBillingLeg = void 0;
var mobx_1 = require("mobx");
var mobx_keystone_1 = require("mobx-keystone");
var load_1 = require("../constants/load");
var AdditionalBillingDocument_1 = require("./AdditionalBillingDocument");
var AdditionalBillingLeg = /** @class */ (function (_super) {
    __extends(AdditionalBillingLeg, _super);
    function AdditionalBillingLeg() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdditionalBillingLeg_1 = AdditionalBillingLeg;
    AdditionalBillingLeg.create = function (data) {
        var documents = data.documents, rest = __rest(data, ["documents"]);
        return new AdditionalBillingLeg_1(__assign(__assign({}, rest), { documents: (0, mobx_keystone_1.arraySet)((documents || []).map(function (doc) { return new AdditionalBillingDocument_1.AdditionalBillingDocument(doc); })) }));
    };
    AdditionalBillingLeg.prototype.update = function (data) {
        var _this = this;
        var _a;
        var documents = data.documents, rest = __rest(data, ["documents"]);
        Object.assign(this, rest);
        if (documents) {
            if (typeof ((_a = this.documents) === null || _a === void 0 ? void 0 : _a.add) === 'function') {
                this.documents.clear();
                documents.forEach(function (docData) {
                    _this.documents.add(new AdditionalBillingDocument_1.AdditionalBillingDocument(docData));
                });
            }
            else {
                // Fallback if constructor initialized `documents` as a standard Array
                this.documents = (0, mobx_keystone_1.arraySet)(documents.map(function (docData) { return new AdditionalBillingDocument_1.AdditionalBillingDocument(docData); }));
            }
        }
    };
    AdditionalBillingLeg.prototype.addDocument = function (doc) {
        if (this.documents && typeof this.documents.add === 'function') {
            this.documents.add(doc);
        }
        else if (Array.isArray(this.documents)) {
            this.documents.push(doc);
        }
    };
    AdditionalBillingLeg.prototype.getDocument = function (documentType) {
        if (documentType === void 0) { documentType = 'additional_document'; }
        return Array.from(this.documents).find(function (doc) { return doc.documentType === documentType; });
    };
    Object.defineProperty(AdditionalBillingLeg.prototype, "onStatus", {
        get: function () {
            switch (this.status) {
                case load_1.ADDITIONAL_BILLING_STATUS.PENDING:
                    return load_1.ON_ADDITIONAL_BILLING_STATUS.PENDING;
                case load_1.ADDITIONAL_BILLING_STATUS.DENIED:
                    return load_1.ON_ADDITIONAL_BILLING_STATUS.DENIED;
                case load_1.ADDITIONAL_BILLING_STATUS.APPROVED:
                    return load_1.ON_ADDITIONAL_BILLING_STATUS.APPROVED;
                case load_1.ADDITIONAL_BILLING_STATUS.INVOICED:
                    return load_1.ON_ADDITIONAL_BILLING_STATUS.INVOICED;
                case load_1.ADDITIONAL_BILLING_STATUS.BILLING_ISSUE:
                    return load_1.ON_ADDITIONAL_BILLING_STATUS.BILLING_ISSUE;
                default:
                    return load_1.ON_ADDITIONAL_BILLING_STATUS.DENIED;
            }
        },
        enumerable: false,
        configurable: true
    });
    var AdditionalBillingLeg_1;
    __decorate([
        mobx_keystone_1.modelAction
    ], AdditionalBillingLeg.prototype, "update", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], AdditionalBillingLeg.prototype, "addDocument", null);
    __decorate([
        mobx_1.computed
    ], AdditionalBillingLeg.prototype, "onStatus", null);
    AdditionalBillingLeg = AdditionalBillingLeg_1 = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/AdditionalBillingLeg')
    ], AdditionalBillingLeg);
    return AdditionalBillingLeg;
}((0, mobx_keystone_1.Model)({
    id: (0, mobx_keystone_1.prop)(),
    dmId: (0, mobx_keystone_1.prop)(),
    baseDmId: (0, mobx_keystone_1.prop)(),
    as400ManifestNumber: (0, mobx_keystone_1.prop)(''),
    baseAs400ManifestNumber: (0, mobx_keystone_1.prop)(''),
    billingType: (0, mobx_keystone_1.prop)(''),
    billOfLadingNumber: (0, mobx_keystone_1.prop)(''),
    status: (0, mobx_keystone_1.prop)(''),
    notes: (0, mobx_keystone_1.prop)(''),
    createdOn: (0, mobx_keystone_1.prop)(''),
    deniedReason: (0, mobx_keystone_1.prop)(''),
    billingIssueDescription: (0, mobx_keystone_1.prop)(''),
    documents: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.arraySet)(); }),
})));
exports.AdditionalBillingLeg = AdditionalBillingLeg;
